<template>
	<div id="app" v-if="isRouterAlive"><router-view></router-view></div>
</template>
<script>
	import config from '../configHttp.js'
export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload //  声明一个变量
		};
	},
	data() {
		return {
			isRouterAlive: true
		};
	},
	created() {
		this.$router.beforeEach((to, from, next) => {
			var routearr = localStorage.getItem('meaurouter');
			if (to.path == '/login' || from.path == '/login' || to.path == '/login_Fin' || from.path == '/login_Fin' || to.path == '/login_Product' || from.path == '/login_Product') {
				next();
			} else {
				var sysUserSTXX = localStorage.getItem('sysUserSTXX');
				if (!sysUserSTXX) {
					localStorage.removeItem("token");
					router.push('/login');
				}
				if (routearr.indexOf(to.meta.roles[0]) == -1) {
					next(from.path);
				} else {
					next();
				}
			}
			let title = document.getElementsByTagName('title')[0]
			if (config.projectType == 'Amat') {
				title.innerText = 'Finance7.0'
			} else {
				title.innerText = '税慧盟·财务本地化'
			}
		});
	},
	methods: {
		reload() {
			// 通过 this.isRouterAlive 控制 router-view 达到刷新效果
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		}
	}
};
</script>
<style>
@import './assets/css/main.css';
</style>
